import { Injectable } from '@angular/core';
import { Subject, timer, takeUntil, BehaviorSubject } from 'rxjs';

interface ToastData {
  title: string;
  description: string;
  type: string;
}

@Injectable({
  providedIn: 'root'
})
export class InfoMessageService {
  private destroy$ = new Subject<void>();
  private seconds: number = 5;
  private toastData$ = new BehaviorSubject<ToastData | null>(null);

  getToastData() {
    return this.toastData$.asObservable();
  }

  showMessage(title: string, description: string, type: string) {
    this.toastData$.next({ title, description, type });
    
    this.destroy$.next();
    timer(this.seconds * 1000).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.toastData$.next(null); // Cerramos estableciendo null
    });
  }

  closeMessage() {
    this.toastData$.next(null);
    this.destroy$.next();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.toastData$.complete();
  }

  changeDuration(seconds: number){
    this.seconds = seconds;
  }

  isMessageVisible(): boolean {
    return this.toastData$.value !== null;
  }

  hideActiveMessage(): void{
    if (this.isMessageVisible()) {
      this.closeMessage();
    }
  }
}
